module.exports = __webpack_public_path__ + "img/thanksgiving.2f954c9b.png";